import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import {LoginRoutingModule} from "./login-routing.module";
import { IconsModule } from '@components/icons/icons.module';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { ZoneConnectionsComponent } from './zone-connections/zone-connections.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { ZoneConnectionViewComponent } from './zone-connections/zone-connection-view/zone-connection-view.component';
import { ConnectZoneViewComponent } from './zone-connections/connect-zone-view/connect-zone-view.component';
import { UtilsModule } from '@util/utils.module';
import { ComponentsV5Module } from '@components/components-v5/components-v5.module';
import { ResizeModule } from '@components/resize/resize.module';
import { SplitInputModule } from '@components/split-input/split-input.module';
import { ScrollableTextComponent } from '@components/components-v5/scrollable-text/scrollable-text.component';



@NgModule({
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        LoginRoutingModule,
        IconsModule,
        BrowserModule,
        FontAwesomeModule,
        MatGridListModule,
        UtilsModule,
        ComponentsV5Module,
        ResizeModule,
        SplitInputModule,
        ScrollableTextComponent
    ],
    declarations: [
        ZoneConnectionsComponent,
        ZoneConnectionViewComponent,
        ConnectZoneViewComponent
    ]
})
export class LoginModule {}
